<template>
  <article>
    <div v-if="!isEditable" class="c-comment c-comment--answer">
      <div class="d-flex">
        <Avatar
          :role="body.user.role"
          :photo="body.user.photo"
          :name="body.user.name"
          class="c-avatar--tiny me-3">
        </Avatar>
        <div class="flex-grow-1 d-flex">
          <div class="flex-grow-1">
            <div class="d-block d-md-flex align-items-center mb-2">
              <div class="d-flex align-items-center white">
                <span class="w-bold">{{body.user.name}}</span>
                <span v-if="isSpecialUser" class="c-comment__label ms-2 d-none d-md-inline-block">
                  {{ userRole }}
                </span>
              </div>
              <i class="c-comment__dot mx-3 d-none d-md-inline-block"></i>
              <time class="w-medium medium-gray d-block d-md-inline-block">{{this.body.date}}</time>
            </div>
            <p class="medium-gray mb-0">
              {{this.body.text}}
            </p>
            <div v-if="attachments.length" class="c-comment__atachments d-flex flex-wrap mt-3">
              <a
                v-for="(photo, pindex) of attachments"
                :href="photo.url"
                :key="photo.id"
                :data-fancybox="`gallery-${body.id}`"
                class="c-photo">
                <div
                  v-if="pindex == 2"
                  class="c-photo__overlay position-absolute d-flex
                    justify-content-center align-items-center"
                >
                  <span class="white fs-25 w-sbold">+ {{body.attachments.length - 2}}</span>
                </div>
                <img class="w-100 h-100 of--cover" :src="photo.url" alt="">
              </a>
              <figure
                v-for="(photo) of hiddenAttachments"
                :href="photo.url"
                :key="photo.id"
                :data-fancybox="`gallery-${body.id}`"
                class="c-photo d-none">
                <img class="w-100 h-100 of--cover" :src="photo.url" alt="">
              </figure>
            </div>
          </div>
          <div v-if="body.user.id === Number(userData.id)">
            <Dropdown v-model="switcherActions">
              <template v-slot:toggle>
                <button
                  @click="switcherActions = !switcherActions"
                  class="c-link c-link--white">
                  <Icon icon="entypo:dots-three-vertical" />
                </button>
              </template>
              <template v-slot:menu>
                <ul>
                  <li>
                    <button @click="openActions('edit')" class="d-flex w-100">
                      <Icon icon="la:pen" class="fs-18 me-2" />
                      <span class="fs-14 w-sbold">Editar</span>
                    </button>
                  </li>
                  <li color="alert">
                    <button @click="openActions('delete')" class="d-flex w-100">
                      <Icon icon="ci:trash-full" class="fs-18 me-2" />
                      <span class="fs-14 w-sbold">Eliminar</span>
                    </button>
                  </li>
                </ul>
              </template>
            </Dropdown>
          </div>
        </div>
      </div>

      <DeleteDialog :data="deleteDialog">
        <template v-slot:navigation>
          <button
            @click="deleteDialog.switcher = false"
            class="c-button c-button--empty c-button--empty-white me-3">
            Cancelar
          </button>
          <button
            @click="deleteAnswer()"
            class="c-button c-button--alerts"
            :disabled="deleteDialog.isLoading"
            :class="{ 'loading' : deleteDialog.isLoading }"
          >
            {{ (deleteDialog.isLoading) ? 'Eliminando...' : 'Eliminar' }}
            <img
              class="c-button__spinner"
              src="@/assets/images/animations/spinner-white.png"
              alt="loading" />
          </button>
        </template>
      </DeleteDialog>
    </div>
    <div v-else>
      <Editor
        mode="update"
        category="answer"
        :parent="`${body.id}Edit`"
        :switcher.sync="isEditable"
        :comment="body"
        :thread.sync="localThread"
        class="c-editor--secondary mt-3"
      />
    </div>
  </article>
</template>

<script>
/* eslint-disable */
import $ from 'jquery';
import '@fancyapps/fancybox/';
import { Icon } from '@iconify/vue2';
import { mapState } from 'vuex';

import Editor from './Editor.vue';
import Avatar from '../../Avatar.vue';
import Dropdown from '../../ui/Dropdown.vue';
import DeleteDialog from '../../ui/Dialog.vue';

export default {
  data() {
    return {
      attachments: [],
      hiddenAttachments: [],

      isEditable: false,
      switcherActions: false,

      deleteDialog: {
        switcher: false,
        title: '¿Estas seguro de eliminar la respuesta?',
        icon: 'iconf-trash-outlined',
        body: 'Recuerda que al eliminarla ya no podrás recuperarlo',

        isLoading: false,
      },

      localThread: [],
    }
  },
  components: {
    Editor,
    Avatar,

    Icon,
    Dropdown,
    DeleteDialog,
  },
  props: ['body', 'thread'],
  computed: {
    ...mapState({
      userData: (state) => state.user.userData,
    }),
    
    isSpecialUser: function() {
      return ['subscriber', 'teacher', 'education', 'teacher-pro', 'agent', 'team', 'core', 'administrator'].includes(this.body.user.role);
    },
    userRole: function() {
      let role = '';

      switch (this.body.user.role) {
        case 'subscriber':
          role = 'Premium';
          break;

        case 'teacher':
        case 'teacher-pro':
          role = 'Docente';
          break;

        case 'agent':
        case 'team':
        case 'education':
        case 'core':
        case 'administrator':
          role = 'Team Arcux';
          break;
      }

      return role;
    },
  },
  watch: {
    body() {
      this.initAtachments();
    },
    localThread() {
      this.$emit('update:thread', this.localThread);
    },
  },
  mounted() {
    $('[data-fancybox="gallery"]').fancybox();

    this.localThread = [...this.thread];

    this.initAtachments();
  },
  methods: {
    initAtachments() {
      if(this.body.attachments.length > 2) {
        this.attachments        = this.body.attachments.slice(0, 3);
        this.hiddenAttachments  = this.body.attachments.slice(3);
      } else {
        this.attachments = this.body.attachments;
      }
    },
    openActions(action) {
      if (action === 'edit') {
        this.isEditable = true;
      } else if (action === 'delete') {
        this.deleteDialog.switcher = true;
      }

      this.switcherActions = false;
    },

    deleteAnswer() {
      this.deleteDialog.isLoading = true;

      const request = `${window.arcux.site}/api/v1/courses/${this.$route.params.course_id}/annotations/${this.body.id}`;

      fetch(request, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then(res => {
          if(res.status == 200 || res.status < 300){
            return res.json();
          }else{
            throw res;
          }
        })
        .then(response => {
          if (response.status) {
            this.$emit(
              'update:thread',
              this.thread.filter(com => com !== this.body)
            );
          }
        })
        .catch(err => {
          throw err;
        })
        .finally(() => {
          this.deleteDialog.isLoading = false;
        })
    },
  },
}
</script>
